<div class="modalBackground" (click)="onCloseModal()">
</div>
<div class="modal">
  <ng-content></ng-content>
</div>
